import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DataManagerService } from 'src/app/services/DataManager/data-manager.service';
import { BaseComponent } from 'src/app/shared/abstract/base.component';
import { AppConstants } from 'src/app/shared/constants/app-constants';

@Component({
  selector: 'app-add-expense-category-dialog',
  templateUrl: './add-expense-category-dialog.component.html',
  styleUrls: ['./add-expense-category-dialog.component.css'],
})
export class AddExpenseCategoryDialogComponent
  extends BaseComponent
  implements OnInit
{
  public expenseCategoryForm: FormGroup;
  public loged_user = JSON.parse(localStorage.getItem('user') || 'null');
  public expenseCategoryUrl: string;
  types: any;
  categoryTypeUrl: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    dataManagerService: DataManagerService,
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<AddExpenseCategoryDialogComponent>,
  ) {
    super();
    this.service = dataManagerService;
    this.expenseCategoryUrl =
      AppConstants.BASE_URL + AppConstants.ADDEXPENSECATEGORY_URL;
    this.categoryTypeUrl = AppConstants.BASE_URL + '/expense-category-type';
    if (dialogData) {
      this.headings = 'Update Expense Category';
      this.buttonText = 'Update';
    } else {
      this.headings = 'Create Expense Category';
      this.buttonText = 'Save';
    }
  }
  ngOnInit(): void {
    this.getCategoryTypes();
    this.setdonationTypeForm();
  }
  get expenseCategoryFormControl() {
    return this.expenseCategoryForm.controls;
  }
  setdonationTypeForm() {
    this.expenseCategoryForm = this.formBuilder.group({
      cat_name: [
        this.dialogData && this.dialogData.data.cat_name
          ? this.dialogData.data.cat_name
          : '',
        [Validators.required],
      ],
      category_type_id: [
        this.dialogData && this.dialogData.data.category_type_id
          ? this.dialogData.data.category_type_id
          : '',
        [Validators.required],
      ],
    });
  }

  onSubmit() {
    if (this.dialogRef.getState() == 0) {
      this.submitted = true;
      if (this.expenseCategoryForm.invalid) {
        return;
      } else {
        this.loadFlag2 = true;
        if (this.dialogData) {
          this.expenseCategoryForm.value.id = this.dialogData.data.id;
        }
        this.service
          .create(this.expenseCategoryUrl, this.expenseCategoryForm.value)
          .subscribe({
            next: (res: any) => {
              if (res['status'] == 'success') {
                this.loadFlag2 = false;
                this.dialogRef.close(true);
                this.service.showSnackBar(res.message, 'ok', 3000);
              } else {
                this.loadFlag2 = false;
                this.topErrorMessage = res.message;
                this.keys = Object.keys(this.topErrorMessage);
                this.keys1 = Object.values(this.topErrorMessage);
                let i;
                let j;
                const name = ['cat_name'];
                for (i = 0; i < this.keys.length; i++) {
                  for (j = 0; j < name.length; j++) {
                    if (this.keys[i].match(name[j])) {
                      const documents = document.getElementById(name[j]);
                      if (documents) {
                        documents.style.borderColor = '#a94442';
                        documents.style.display = 'block';
                      }
                    }
                  }
                }
              }
            },
            error: (error) => {
              this.loadFlag2 = false;
              this.service.showSnackBar(error.message, 'ok', 3000);
            },
          });
      }
    } else {
      this.loadFlag2 = false;
      this.dialogRef.close(true);
    }
  }
  cancel() {
    this.loadFlag2 = false;
    this.dialogRef.close(true);
  }
  getCategoryTypes() {
    this.service.getAllList(this.categoryTypeUrl).subscribe((res: any) => {
      this.types = res.data;
    });
  }
}
